module.exports = {
  footerText: 'Copyright Perlène - Solution Entreprise © 2009-2023',
};
